import {
    ADDUPDATESMSPROVIDER_SUCCESS,
    ADDUPDATESMSPROVIDER_FAILED,
    RESET_ADDUPDATESMSPROVIDER,
    LOADING_ADDUPDATESMSPROVIDER,
    NETWORK_ERROR_ADDUPDATESMSPROVIDER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDUPDATESMSPROVIDER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADDUPDATESMSPROVIDER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADDUPDATESMSPROVIDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADDUPDATESMSPROVIDER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADDUPDATESMSPROVIDER:
            return (state = initialState);
        default:
            return state;
    }
};
